module.exports = "//public.zight.com/packs/media/images/markers/m_9-63b8dd600c7b2121b07fd47026e616b0.svg";